import DashboardPreview from 'features/Admin/Roles/RoleManager/components/RoleTabs/components/DashboardPreview';
import type { LayoutItem, WidgetData } from 'features/dashboard/types/widgetTypes';
import React from 'react';
import type { RoleFormData } from '../../../types/Roles.types';

interface DashboardViewTabProps {
  formData: RoleFormData;
  widgetData?: WidgetData;
  openWidgetSelector?: () => void;
  edit?: boolean;
  compactPreview?: boolean;
}

const DashboardViewTab: React.FC<DashboardViewTabProps> = ({
  formData,
  widgetData,
  openWidgetSelector,
  edit = false,
  compactPreview = false,
}) => {
  return (
    <div className="d-flex flex-column w-100 h-100">
      <div className="d-flex flex-column w-100 h-100 user-select-none position-relative">
        <div className="d-flex flex-row flex-grow-1 overflow-auto border border-1 border-white bg-background">
          <DashboardPreview
            definedWidgetData={widgetData}
            list={formData.layout}
            setList={() => {}}
            onRemoveWidget={() => {}}
            openWidgetSelector={openWidgetSelector}
            uninteractable={true}
            edit={edit}
            compactPreview={compactPreview}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardViewTab;
